import { markInjectable } from "./container";

import type { Scope, ClassConstructor } from "./container";

export interface InjectableOptions {
  scope?: Scope;
  deep?: ClassConstructor[]; // 👈 新增
}

export function Injectable(
  options: InjectableOptions = {},
): (target: unknown) => ClassConstructor {
  return function (target: unknown): ClassConstructor {
    const OriginalClass = target as ClassConstructor;
    const scope = options.scope ?? "singleton";
    const deps = options.deep ?? [];

    // 创建代理类
    class ProxyClass extends OriginalClass {
      // 使用静态属性
      static _allowConstruct: boolean = false;

      constructor(...args: unknown[]) {
        // 直接使用类名访问静态属性
        if (!ProxyClass._allowConstruct) {
          throw new Error(
            `禁止直接 new ${OriginalClass.name}，请通过依赖注入容器获取实例。`,
          );
        }
        super(...args);
      }
    }

    // 保留原始类名
    Object.defineProperty(ProxyClass, "name", {
      value: OriginalClass.name,
      writable: false,
    });

    // 直接返回类，不需要额外的类型转换
    markInjectable(ProxyClass as ClassConstructor, scope, deps);

    return ProxyClass as ClassConstructor;
  };
}
